// extracted by mini-css-extract-plugin
export default {"preview-wrapper":"TravelReceiptsPreview_preview-wrapper__3lJXz"};